module.exports = __webpack_public_path__ + "static/stone_defender-8a4c142eac7bc64fe4b6782eceb165f4.png";